module.exports = __webpack_public_path__ + "static/carousel4-b31354aa41a18d7b91a5008b9d949a4c.jpg";